// extracted by mini-css-extract-plugin
export default {"invalid":"SearchBar_invalid__LNveJ","shake":"SearchBar_shake__hhArV"};